const deepClone = function(item, cache) {
  if (typeof item !== "object" || item === null) return item;
  if (!cache) {
    cache = new Set();
  }
  if (cache.has(item)) return item;
  let result = Object.assign({}, item);
  cache.add(result);
  for (const key of Object.keys(item)) {
    if (Array.isArray(item[key])) {
      for (const i in item[key]) {
        result[key][i] = deepClone(item[key][i]);
      }
    } else if (typeof item[key] !== "object" && item[key] !== null) {
      result[key] = deepClone(item[key]);
    }
  }
  return result;
};

export default deepClone;
